/**
 * Created by mark on 05/03/2018.
 */


import React  from 'react';
import Wizard from '../wizards/wizard.js';
import {Name , EnterStudents , Completed , Comfirmation , Settings} from '../wizards/class_import';
import {Translation} from '../../store';


export default class StudentImport extends React.Component {

    constructor(props) {
        super(props);

    }

    renderPanelHeader(){
        return <div>
            <h1>{Translation.get(12654 , 'Import Students')}</h1>
        </div>
    }

    render() {

        let Steps = [Name , EnterStudents , Comfirmation , Settings , Completed];
        return <div>
                <Wizard name="" stepsNavigation={true} steps={Steps} />
        </div>;
    }

}


